<template>
  <!-- 75rem limits the width to snugly fit up to 5 entries -->
  <section class="container md:max-w-[75rem]">
    <div class="mt-4 bg-white-darker px-2 py-3 md:px-4">
      <h2 class="text-xl font-bold" v-html="category.name"></h2>
    </div>
    <div class="mt-2 block px-2 py-3 md:px-4">
      <p v-html="category.description" />
    </div>
    <!-- Mobile -->
    <ol
      class="ltr relative -mx-4 flex basis-1/2 snap-x snap-mandatory scroll-px-6 flex-row flex-nowrap gap-3 overflow-x-scroll px-6 text-sm md:hidden"
    >
      <ProductOptionSelectEntry
        v-for="productOption in category.productOptions"
        :key="`mobile-${productOption.sku}`"
        :option="productOption"
        :category="category"
        :selected="selectedId === productOption.id"
        @toggle="store.toggleActiveProductOption(productOption, category, true)"
      />
    </ol>

    <!-- Desktop -->
    <ol class="relative hidden flex-row flex-wrap gap-3 px-3 md:flex">
      <ProductOptionSelectEntry
        v-for="productOption in category.productOptions"
        :key="`desktop-${productOption.sku}`"
        :option="productOption"
        :category="category"
        :selected="selectedId === productOption.id"
        @toggle="store.toggleActiveProductOption(productOption, category, true)"
      />
    </ol>
  </section>
</template>

<script setup lang="ts">
import ProductOptionSelectEntry from '@/components/ProductOptions/ProductOptionSelectEntry.vue';
import { useExtraOptionsStore } from '@/stores/ExtraOptionsStore';
import { ProductOptionCategoryObject } from '@/types/joostconnector';
import { computed, PropType } from 'vue';

const store = useExtraOptionsStore();

const props = defineProps({
  category: {
    type: Object as PropType<ProductOptionCategoryObject>,
    required: true,
  },
});

const selectedId = computed(() => store.selectedOptions[props.category.id]?.id);
</script>
